<template>
    <div class="live-event-stats-grid">
        <h3 class="title">Live Events Stats</h3>
        <div class="live-viewers">
            <div class="image"><img src="/assets/new-moderator/Icon-Viewer.svg" alt=""></div>
            <div class="count-title-g">
                <div class="count">{{data.visited_during_session}}</div>
                <div class="l-title">Live Viewers</div>
            </div>
        </div>
        <div class="registrations">
            <div class="image"><img src="/assets/new-moderator/Icon-Resgistrations.svg" alt=""></div>
            <div class="count-title-g">
                <div class="count">{{data.total_registered}}</div>
                <div class="l-title">Registration</div>
            </div>
        </div>
        <div class="countries">
            <div class="image"><img src="/assets/new-moderator/Icon-Countries.svg" alt=""></div>
            <div class="count-title-g">
                <div class="count">{{data.countries_visited}}</div>
                <div class="l-title">Countries</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default  {
        props : ['data'],
    }
</script>
<style scoped>
    .live-event-stats-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 18px;
    }
    .live-event-stats-grid .title {
        grid-column: 1 / 3;
        font-size: 18px;
    }
    .live-event-stats-grid .live-viewers .image, .live-event-stats-grid .registrations .image, .live-event-stats-grid .countries .image {
        width: 44px;
        height: 44px;
    }
    .live-event-stats-grid .live-viewers, .live-event-stats-grid .registrations, .live-event-stats-grid .countries {
        display: grid;
        grid-template-columns: 0fr 1fr;
        grid-gap: 10px;
    }
    img {
        max-width: 100%;
    }
    .count-title-g {
        display: grid;
        line-height: 1;
    }
    .count-title-g .l-title {
        color: #9B9B9B;
        font-size: 12px;
    }
    .count-title-g .count {
        font-size: 18px;
        font-weight: 600;
    }
</style>
